<template>
  <!-- Menú inferior del usuario empleado en mobile (reemplaza al sidebar) -->
  <v-footer app padless height="72" class="employee-nav">
    <router-link :to="news_path" class="employee-nav__item">
      <span class="employee-nav__icon">
        <v-badge :value="$store.state.news_unread > 0" :content="$store.state.news_unread" color="orange" overlap>
          <v-icon>mdi-bullhorn-outline</v-icon>
        </v-badge>
      </span>
      <span>Novedades</span>
    </router-link>

    <router-link :to="my_payslips_path" class="employee-nav__item">
      <span class="employee-nav__icon">
        <v-badge :value="$store.state.my_payslips_pending > 0" :content="$store.state.my_payslips_pending" color="orange" overlap>
          <v-icon>mdi-file-document-outline</v-icon>
        </v-badge>
      </span>
      <span>Mis recibos</span>
    </router-link>

    <router-link :to="my_account_path" class="employee-nav__item">
      <span class="employee-nav__icon">
        <v-icon>mdi-account-circle-outline</v-icon>
      </span>
      <span>Mi cuenta</span>
    </router-link>

    <v-bottom-sheet v-model="more_sheet">
      <template v-slot:activator="{ on, attrs }">
        <button type="button" class="employee-nav__item" :class="{ 'employee-nav__item--open': more_sheet }" v-bind="attrs" v-on="on">
          <span class="employee-nav__icon">
            <v-icon>mdi-dots-horizontal</v-icon>
          </span>
          <span>Más</span>
        </button>
      </template>
      <v-sheet class="employee-sheet">
        <div class="employee-sheet__handle"></div>
        <div class="employee-sheet__title">Más opciones</div>
        <v-list>
          <v-list-item v-for="item in more_items" :key="item.title" disabled>
            <v-list-item-icon class="mr-4">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
              <v-list-item-subtitle>Próximamente</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-sheet>
    </v-bottom-sheet>
  </v-footer>
</template>

<script>
import Constant from "@/constants/sections";
import { myPayslipService } from "@/libs/ws/myPayslipService";

export default {
  name: "EmployeeBottomNav",
  data() {
    return {
      my_payslips_path: "/" + Constant.SECTION_MY_PAYSLIPS,
      my_account_path: "/" + Constant.SECTION_MY_ACCOUNT,
      news_path: "/" + Constant.SECTION_NEWS,
      more_sheet: false,
      more_items: [
        { title: "Justificaciones", icon: "mdi-text-box-check-outline" },
        { title: "Licencias", icon: "mdi-calendar-account-outline" },
      ],
    };
  },
  mounted() {
    myPayslipService
      .pending_count()
      .then((response) => {
        if (response.status) this.$store.commit("setMyPayslipsPending", response.result);
      })
      .catch((e) => console.log(e));
  },
};
</script>
